import DocumentHome from './DocumentHome.vue'
import ReportOverview from './report/ReportOverview.vue'
import EditReport from './report/edit/EditReport.vue'
import EditReportIro from './report/iro/edit/EditReportIro.vue'

const documentRoutes = [
	{
		path: 'report',
		component: ReportOverview,
		props: () => ({
			permission: ['report', 'r']
		})
	},
	{
		path: 'report/edit',
		component: EditReport,
		props: (route) => ({
			permission: ['report', 'r'],
			documentType: route.query?.documentType,
			orgId: Number(route.query?.orgId),
			documentYear: Number(route.query?.documentYear),
			source: route.query?.source,
			expectedDate: route.query?.expectedDate
		})
	},
	{
		path: 'report/edit/:reportId',
		component: EditReport,
		props: (route) => ({
			reportId: Number(route.params?.reportId),
			documentType: route.query?.documentType,
			permission: ['report', 'r']
		})
	},
	{
		path: 'report/iros/:reportId',
		component: EditReportIro,
		props: (route) => ({
			reportId: Number(route.params?.reportId),
			permission: ['report', 'r']
		})
	}
]

export const DOCUMENT_ROUTES = [
	{
		path: '/document',
		component: DocumentHome,
		children: [...documentRoutes]
	}
]
